"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vesselCorrectionColumnProps = exports.UploadHistoryColumnProps = exports.DeletedListColumnProps = void 0;
const constants_1 = require("utils/constants");
const custom_filter_1 = require("components/atoms/custom-filter");
const AdjustmentStockpileColumnProps = [
    {
        show: true,
        field: 'is_duplicate',
        title: 'Is Duplicated',
        width: '130',
        filter: 'boolean',
        locked: true
    },
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: '150',
        filter: 'text',
        locked: true
    },
    {
        show: true,
        field: 'silo',
        title: 'Gate',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'main_entrance_in',
        title: 'Entrance In',
        width: '150',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        field: 'gate_in',
        title: 'Gate In',
        width: '150',
        filter: 'date',
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        field: 'queue_time_in',
        title: 'Queue Time',
        width: '150',
        filterCell: custom_filter_1.IntervalPicker
    },
    {
        show: true,
        field: 'gate_out',
        title: 'Exit Gate',
        width: '150',
        filterCell: custom_filter_1.FilterTImePicker,
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        field: 'lead_time_in',
        title: 'Lead Time',
        width: '150',
        filterCell: custom_filter_1.FilterTImePicker
    },
    {
        show: true,
        field: 'contractor_code',
        title: 'Contractor Code',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler No',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'vessel_1_no',
        title: 'Vessel No 1',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'vessel_2_no',
        title: 'Vessel No 2',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'total_volume',
        title: 'Total Capacity',
        width: '150',
        filter: 'numeric',
    },
    {
        show: true,
        field: 'brand_code',
        title: 'Brand',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'driver_name',
        title: 'Driver',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    }
];
const DeletedListColumnProps = [
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'gate_in',
        title: 'Date',
        width: '180px',
        filter: 'text',
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '300px',
        filter: 'text'
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler No',
        width: '100px',
        filter: 'text'
    },
    {
        show: true,
        field: 'total_volume',
        title: 'Total Capacity',
        width: '100px',
        filter: 'numeric'
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Deleted By',
        width: '150px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Deleted Date',
        width: '150px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY}`
    },
    {
        show: true,
        field: 'reason',
        title: 'Reason',
        width: '200px',
        filter: 'text'
    }
];
exports.DeletedListColumnProps = DeletedListColumnProps;
const UploadHistoryColumnProps = [
    {
        show: true,
        field: 'action',
        title: 'Action',
        width: '75',
    },
    {
        show: true,
        field: 'filename',
        title: 'File Name',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'type',
        title: 'Type',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'status',
        title: 'Status',
        width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'log_message',
        title: 'Log',
        width: '110',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'uploaded_at',
        title: 'Uploaded At',
        width: '175px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'uploaded_by',
        title: 'Uploaded by',
        width: '175px',
        filter: 'text'
    },
];
exports.UploadHistoryColumnProps = UploadHistoryColumnProps;
const vesselCorrectionColumnProps = [
    {
        show: true,
        field: 'action',
        title: 'Action',
        width: '75',
    },
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: '170',
        filter: 'text',
    },
    {
        show: true,
        field: 'gate_in_str',
        title: 'Date',
        width: '150',
        filter: 'text',
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        // width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler',
        width: '110',
    },
    {
        show: true,
        field: 'vessel1_no',
        title: 'Vessel 1',
        width: '110',
    },
    {
        show: true,
        field: 'capacity_volume1',
        title: 'Capacity 1',
        width: '110',
    },
    {
        show: true,
        field: 'vessel2_no',
        title: 'Vessel 2',
        width: '110',
    },
    {
        show: true,
        field: 'capacity_volume2',
        title: 'Capacity 2',
        width: '110',
    },
];
exports.vesselCorrectionColumnProps = vesselCorrectionColumnProps;
exports.default = AdjustmentStockpileColumnProps;
